import React from "react";
import { Placeholder, Spinner } from "react-bootstrap";

const DashboardCardSkeleton = ({
  bg1 = "#f8f9fa",
  bg2 = "#e9ecef",
  styles,
}) => {
  return (
    <div
      className={`${styles.Card} shadow h-auto`}
      style={{
        backgroundImage: `linear-gradient(0deg, ${bg1} 0%, ${bg2} 80%)`,
      }}
    >
      {/* Top Row (Text + Icon) */}
      <div className="d-flex justify-content-between align-items-center w-100 mb-2">
        <Placeholder as="p" animation="wave" className="w-50 mb-0">
          <Placeholder xs={6} className="rounded" />
        </Placeholder>

        <div
          className={`${styles.iconCard} d-flex align-items-center justify-content-center`}
        >
          <Spinner animation="border" size="sm" />
        </div>
      </div>

      {/* Bottom Row (Number + Badge) */}
      <div className="d-flex justify-content-between align-items-center w-100">
        <Placeholder as="p" animation="wave" className="fs-5 fw-bold m-0 w-50">
          <Placeholder xs={8} className="rounded" />
        </Placeholder>

        <Placeholder
          as="span"
          animation="wave"
          className="rounded-pill d-inline-block"
          style={{ width: "70px", height: "20px" }}
        />
      </div>
    </div>
  );
};

export default DashboardCardSkeleton;
